/** Shorten an address-style string for compact display.
 *  `0xabc...123` for hex, `alice.near` left intact when short enough.
 *  Operates on chars, not bytes, so it's safe for Unicode. Returns the
 *  input unchanged when `tail === 0` to guard the underflow that would
 *  otherwise hit the reverse iterator below. */
export function truncateMiddle(s: string, head: number, tail: number): string {
  if (tail === 0) return s;
  const chars = [...s];
  if (chars.length <= head + tail + 1) return s;
  return `${chars.slice(0, head).join("")}…${chars.slice(-tail).join("")}`;
}
